import { create } from "zustand";

export const createLicenseSlice = (set) => ({
  serviceStatus: null,
  setServiceStatus: (data) => set({ serviceStatus: data }),
});
